<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>


        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-content px-0 pt-3">
                    <template v-if="vr_type == 'summary'">
                        <table class="table" v-if="vr_fiscal_year != '' && vr_month != '' && vr_month_to != ''">
                            <thead>
                                <tr class="table-head">
                                <th scope="col">Fiscal Year</th>
                                <th scope="col">Preview Report</th>
                                <th scope="col">Download Excel</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="display: none;"></tr>
                                <tr class="table-row hover-bg">
                                    <td>{{vr_fiscal_year}}</td>
                                    <td><a href="#" @click="viewDetails(vr_fiscal_year, vr_month, vr_month_to)"><i class="fas fa-list"> </i> Preview Report</a></td>
                                    <td><a href="#" @click="getSalaryReport(vr_fiscal_year, vr_month, vr_month_to)"><i class="far fa-file-excel"> </i> Download Report (Excel)</a></td>
                                </tr>

                            </tbody>
                        </table>
                    </template>
                    <template v-else-if="vr_type == 'detailed'">
                        <table class="table" v-if="vr_fiscal_year != '' && vr_month != '' && vr_month_to != ''">
                            <thead>
                                <tr class="table-head">
                                <th scope="col">Fiscal Year</th>
                                <th scope="col">Preview Report</th>
                                <th scope="col">Download Excel</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="display: none;"></tr>
                                <tr class="table-row hover-bg">
                                    <td>{{vr_fiscal_year}}</td>
                                    <td><a href="#" @click="viewDetails(vr_fiscal_year, vr_month, vr_month_to)"><i class="fas fa-list"> </i> Preview Report</a></td>
                                    <td><a href="#" @click="getDetailReport(vr_fiscal_year, vr_month, vr_month_to)"><i class="far fa-file-excel"> </i> Download Report (Excel)</a></td>
                                </tr>

                            </tbody>
                        </table>
                    </template>
                    <template v-else>
                        <p class="text-center">Please select report type from the above box.</p>
                    </template>
                </div>
            </div>
        </div>


        <b-modal id="vr-payroll-report-detailed" dialog-class="modal-xxl" size="xl" scrollable  hide-footer title="Detailed Variance Report" v-if="vr_type != 'summary'">
            <b-overlay rounded="sm">
                <div class="clearfix row py-2 mb-2 border-bottom">
                    <div class="col-md-12 px-3 company-form-box-title text-center">{{variance_report_header.company_name}}</div>
                    <div class="col-md-12 px-3 company-form-box-title text-center">{{variance_report_header.report_title}}</div>

                </div>

                    <table class="employee-list-table dataTable table-overflow table-sticky mpf_table_wrapper" v-if="paginatedData2.length > 0" style="white-space: nowrap;"> <!-- Mustafijur: 13-05-2026 -->
                    <thead>
                        <tr class="table-head">

                            <template v-for="(detail, index) in paginatedData2[0]">
                                <template v-if="static_default_fields.includes(index)">
                                    <td class="text-center align-middle" rowspan="2">{{index}}</td>
                                </template>
                                <template v-else>
                                    <td  class="text-center align-middle" rowspan="1" colspan="4">{{ucword(index.replaceAll("_", " "))}}</td>
                                </template>
                            </template>
                        </tr>

                        <!-- alpha fix added class="table-head custom-table-head-report" -->
                        <tr class="table-head custom-table-head-report">

                            <template v-for="(detail, index) in paginatedData2[0]">
                                <template v-if="static_default_fields.includes(index)">

                                </template>
                                <template v-else>
                                    <template v-for="(detail2, index2) in detail">
                                        <template v-if="index2 != 'change_in_pc' ">
                                            <td  class="text-center align-middle" rowspan="1" >{{ucword(index2)}}</td>
                                        </template>
                                            <template v-else>
                                            <td  class="text-center align-middle" rowspan="1" >Change in %</td>
                                        </template>

                                    </template>
                                </template>
                            </template>
                        </tr>
                        </thead>
                        <tbody class="" style="">
                        <template v-for="(detail, index) in paginatedData2">
                            <tr class="table-row">

                                <template v-for="(employee, index2) in detail">
                                    <template v-if="static_default_fields.includes(index2)">
                                        <td class="text-center align-middle">{{employee}}</td>
                                    </template>
                                        <template v-else>
                                        <template v-for="(detail2, index2) in employee">
                                        <template>
                                            <td  class="text-center align-middle" rowspan="1" >{{detail2}}</td>
                                        </template>
                                    </template>
                                    </template>

                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <div v-if="paginatedData2.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{empty_result}}</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next"  base-url="#" first-number last-number ></b-pagination-nav></div>
            </b-overlay>
        </b-modal>
        <b-modal id="vr-payroll-report" dialog-class="modal-xxl" size="xl" scrollable  hide-footer title="Variance Report">
            <b-overlay rounded="sm">
                <div class="clearfix row py-2 mb-2 border-bottom">
                    <div class="col-md-6 px-3 company-form-box-title">{{vr_fiscal_year}}</div>
                    <!--<div class="col-md-6">
                        <b-input-group class="mb-0 custom-search ml-auto mr-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>-->
                </div>

                <table class="table" v-if="paginatedData.length > 0">
                    <thead class="" style="">
                        <tr class="table-head">
                            <td class="align-middle">Summary</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-center align-middle">Total</td>
                                <td class="text-center align-middle" :key="detail.month_name">{{detail.month_name}}-{{detail.payrun_year}}<br />Change</td>
                                <td class="text-center align-middle">% Change</td>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Total number of employees</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{detail.total_employees}}</td>
                                <td class="text-right align-middle">{{detail.employee_change}}</td>
                                <td class="text-right align-middle">{{detail.employee_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Number of leavers</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{detail.total_leaver}}</td>
                                <td class="text-right align-middle">{{detail.leaver_change}}</td>
                                <td class="text-right align-middle">{{detail.leaver_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Number of joiners</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{detail.total_joiner}}</td>
                                <td class="text-right align-middle">{{detail.joiner_change}}</td>
                                <td class="text-right align-middle">{{detail.joiner_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Number of Payslips</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{detail.total_payslips}}</td>
                                <td class="text-right align-middle">{{detail.payslips_change}}</td>
                                <td class="text-right align-middle">{{detail.payslips_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-head">
                            <td class="align-middle">Earnings, Deductions, and Taxes</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-center align-middle">Total</td>
                                <td class="text-center align-middle">Change</td>
                                <td class="text-center align-middle">% Change</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Basic Salary</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.basic_salary)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.basic_change)}}</td>
                                <td class="text-right align-middle">{{detail.basic_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">House Rent Allowance</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.house_rent_allowance)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.hra_change)}}</td>
                                <td class="text-right align-middle">{{detail.hra_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Conveyance Allowance</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.conveyance_allowance)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.conv_change)}}</td>
                                <td class="text-right align-middle">{{detail.conv_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Medical Allowance</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.medical_allowance)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.medical_change)}}</td>
                                <td class="text-right align-middle">{{detail.medical_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg" v-if="arrear_basic_flag">
                            <td class="align-middle">Arrear Basic Salary</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.arrear_basic_salary)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.arrear_basic_change)}}</td>
                                <td class="text-right align-middle">{{detail.arrear_basic_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg" v-if="arrear_hra_flag">
                            <td class="align-middle">Arrear House Rent Allowance</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.arrear_hra)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.arrear_hra_change)}}</td>
                                <td class="text-right align-middle">{{detail.arrear_hra_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg" v-if="arrear_cnv_flag">
                            <td class="align-middle">Arrear Conveyance Allowance</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.arrear_conveyance)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.arrear_conv_change)}}</td>
                                <td class="text-right align-middle">{{detail.arrear_conv_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg" v-if="arrear_medical_flag">
                            <td class="align-middle">Arrear Medical Allowance</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.arrear_medical)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.arrear_medical_change)}}</td>
                                <td class="text-right align-middle">{{detail.arrear_medical_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg" v-if="medical_reimbursement_flag">
                            <td class="align-middle">Medical Reimbursement</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.medical_reimbursement)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.mri_change)}}</td>
                                <td class="text-right align-middle">{{detail.mri_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Earning Bonus</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.earning_bonus)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.earning_bonus_change)}}</td>
                                <td class="text-right align-middle">{{detail.earning_bonus_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Gross Earnings</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.gross_earning)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.gross_earning_change)}}</td>
                                <td class="text-right align-middle">{{detail.gross_earning_persentage_change}}</td>
                            </template>
                        </tr>

                        <template v-if="post_gross_deductions">
                            <tr class="table-row hover-bg" v-for="(post_deduction, pst_index) in post_deduction_array">

                                <td class="align-middle">{{post_deduction.a}}</td>

                                <template v-for="(detail, index) in paginatedData">
                                    <template v-for="(v, i) in detail.post_gross_deductions">
                                        <td class="text-right align-middle" v-if="pst_index == i">{{formatMoney(v.b)}}</td>
                                        <td class="text-right align-middle" v-if="pst_index == i">{{formatMoney(v.c)}}</td>
                                        <td class="text-right align-middle" v-if="pst_index == i">{{v.d}}</td>
                                    </template>
                                </template>

                            </tr>
                        </template>

                        <template v-if="pre_gross_deductions">
                            <tr class="table-row hover-bg" v-for="(pre_deduction, pre_index) in pre_deduction_array">

                                <td class="align-middle">{{pre_deduction.a}}</td>

                                <template v-for="(detail, index) in paginatedData">
                                    <template v-for="(v, i) in detail.pre_gross_deductions">
                                        <td class="text-right align-middle" v-if="pre_index == i">{{formatMoney(v.b)}}</td>
                                        <td class="text-right align-middle" v-if="pre_index == i">{{formatMoney(v.c)}}</td>
                                        <td class="text-right align-middle" v-if="pre_index == i">{{v.d}}</td>
                                    </template>
                                </template>

                            </tr>
                        </template>

                        <tr class="table-row hover-bg">
                            <td class="align-middle">Monthly Tax</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.total_monthly_tax)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.monthly_tax_change)}}</td>
                                <td class="text-right align-middle">{{detail.monthly_tax_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">One-off Tax</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.total_one_off_tax)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.oneoff_tax_change)}}</td>
                                <td class="text-right align-middle">{{detail.oneoff_tax_persentage_change}}</td>
                            </template>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td class="align-middle">Net Pay</td>
                            <template v-for="(detail, index) in paginatedData">
                                <td class="text-right align-middle">{{formatMoney(detail.net_salary_paid)}}</td>
                                <td class="text-right align-middle">{{formatMoney(detail.net_pay_change)}}</td>
                                <td class="text-right align-middle">{{detail.net_pay_persentage_change}}</td>
                            </template>
                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{empty_result}}</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next"  base-url="#" first-number last-number ></b-pagination-nav></div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: [ 'vr_month' , 'vr_fiscal_year' , 'vr_type' , 'vr_month_to'],
        components: {

        },
        data(){

            return {



                search:'',
                search2:'',
                length: 100,
                length2: 100,
                pagination: {currentPage: 1, pages:1},
                pagination2: {currentPage: 1, pages:1},

                empty_result : 'Please hold tight! We are preparing the report data for you!',

                fiscal_year : '',

                payroll_reporting_data : [],
                details : [],
                vd_details : [],
                showoverlay : true,
                medical_reimbursement_flag : false,
                arrear_basic_flag : false,
                arrear_hra_flag : false,
                arrear_cnv_flag : false,
                arrear_medical_flag : false,
                post_gross_deductions : false,
                pre_gross_deductions : false,
                loader: false,
                /***Ali */
                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                post_deduction_array:[],
                post_deduction_array_new:[],
                pre_deduction_array:[],
                variance_report_details:[],
                variance_report_header:[],
                show_selected:'',
                static_default_fields: ['Name Of Employee','Job Position','Employee Id','Employee Code'],

            }
        },
        methods:{

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            getPayrollReporting: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting' , {
                    params: {

                    }
                }).then(function(response){
                    this.payroll_reporting_data = response.data;
                    //console.log(this.payroll_reporting_data);

                }.bind(this));
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    if(val[i].length == 2 && val[i] == 'pf'){
                        val[i] = val[i].toUpperCase();
                    }else{
                        val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                    }
                }
                return val.join(' ');
            },
            viewDetails: function(year, month, month_to)
            {
                if(!this.checkNet()) return false;
                var months = ["", "January", "February", "March", "April", "May", "June",
           "July", "August", "September", "October", "November", "December" ];

                this.fiscal_year = year;

                if(this.column_selected.indexOf('name') === -1){
                    this.column_selected.unshift('name');
                }

                let formData = new FormData();
                if(this.vr_type == 'summary'){
                    formData.append('fiscal_year', year);
                    formData.append('month_from', month);
                    formData.append('month_to', month_to);
                    formData.append('report_type', this.vr_type);
                }else{
                    formData.append('fiscal_year', year);
                    formData.append('month_from', month);
                    formData.append('month_to', month_to);
                    formData.append('report_type', this.vr_type);
                }
                formData.append('report_name', 'vr');
                let url = this.$api_url + '/payroll-custom-report-data';
                let currentObj = this;
                this.details = [];
                this.variance_report_details = [];
                this.variance_report_header = [];
                axios.post(url, formData).then(function (response)
                {


                    this.empty_result = 'Please hold tight! We are preparing the report data for you!';

                    if(this.vr_type == 'summary')
                    {
                        this.details = response.data;
                        console.log('summary');
                        console.log(this.details[0].medical_reimbursement);
                        if(this.details[0].medical_reimbursement){
                            this.medical_reimbursement_flag = true;
                        }
                        if(this.details[0].arrear_basic_salary){
                            this.arrear_basic_flag = true;
                        }
                        if(this.details[0].arrear_hra){
                            this.arrear_hra_flag = true;
                        }
                        if(this.details[0].arrear_conveyance){
                            this.arrear_cnv_flag = true;
                        }
                        if(this.details[0].arrear_medical){
                            this.arrear_medical_flag = true;
                        }
                        if(this.details[0].post_gross_deductions){
                            this.post_gross_deductions = true;
                            this.post_deduction_array = this.details[0].post_gross_deductions;
                        }
                        if(this.details[0].pre_gross_deductions){
                            this.pre_gross_deductions = true;
                            this.pre_deduction_array = this.details[0].pre_gross_deductions;
                        }
                        if(this.details.length == 0)
                            this.empty_result = 'No Result Found!';


                    }
                    else
                    {


                        this.variance_report_header = response.data.header_info;

                        this.variance_report_details = response.data.data;


                        if(this.variance_report_details.length == 0)
                            this.empty_result = 'No Result Found!';
                    }


                    //console.log(this.post_deduction_array);



                }.bind(this)).catch(function (error){ currentObj.serverError(error);});

                if(this.vr_type == 'summary')
                {
                    this.$bvModal.show('vr-payroll-report');
                }
                else
                {
                    this.$bvModal.show('vr-payroll-report-detailed');
                }


            },
            getDetailReport: function(fiscal_year, month, month_to)
            {
                if(!this.checkNet()) return false;
                this.loader = true;
                //this.loader = false;
                let formData = new FormData();
                formData.append('fiscal_year', fiscal_year);
                formData.append('month_from', month);
                formData.append('month_to', month_to);
                formData.append('report_type', this.vr_type);
                formData.append('report_name', 'vr');
                formData.append('report', 1);
                const config = {
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }
                let url = this.$api_url + '/payroll-custom-report-data';
                //console.log(url);
                axios.post(url, formData, config).then(function (response)
                {
                    //this.payroll_reporting_data = response.data;
                    //console.log(response.data.original);
                    //var fileURL = this.$api_url+'/income_tax_report?grid_report=Excel&fiscal_year='+fiscal_year;

                    if(response.data =='No Payrun found for selected months.')
                    {
                        this.$bvToast.toast(response.data, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true

                        });
                        this.loader = false;
                    }
                    else
                    {
                        // var fileURL = response.data;
                        // this.download_file(fileURL);
                        this.loader = false;
                        if(response.data.type =='application/json'){
                            let file = new Blob([response.data], {type: 'application/json'});
                            const cast = Promise.resolve(file.text());
                            cast.then((value) => {
                                let err_obj = JSON.parse(`${value}`);
                                this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                            });
                        }else{
                            this.global_download_file_content(response);
                        }
                    }


                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.loader = false;
                    }
                });
                return false;
            },
            getSalaryReport: function(fiscal_year, month, month_to)
            {
                if(!this.checkNet()) return false;
                this.loader = true;

                let formData = new FormData();
                formData.append('fiscal_year', fiscal_year);
                formData.append('month_from', month);
                formData.append('month_to', month_to);
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                const config = {
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }
                let url = this.$api_url + '/variance-report-summery';

                axios.post(url, formData, config).then(function (response)
                {
                    //this.payroll_reporting_data = response.data;
                    //console.log(response.data);
                    //var fileURL = this.$api_url+'/income_tax_report?grid_report=Excel&fiscal_year='+fiscal_year;
                    // var fileURL = response.data;
                    // this.download_file(fileURL);
                    this.loader = false;
                    if(response.data.type =='application/json'){
                        let file = new Blob([response.data], {type: 'application/json'});
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                        });
                    }else{
                        this.global_download_file_content(response);
                    }

                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.loader = false;
                    }
                });
                return false;
            },
            formatMoney: function(amount){
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },

            ucword(str)
            {

                if(str)
                {
                    str = str.toLowerCase().replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function(replace_latter) {
                    return replace_latter.toUpperCase();
                    });  //Can use also /\b[a-z]/g
                    return str;  //First letter capital in each word

                }

            },
            getPayrollDefaultField()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting/defaultfields' , {
                }).then(function(response){
                    this.default_fields = response.data;
                    let available_colunms = [];

                    let co = [];
                    var txt = '';
                    this.default_fields.forEach(element => {

                        if(element=='etin')
                        {
                            txt = 'e-TIN';
                        }
                        else if(element=='jobposition')
                        {
                            txt = 'Job Position';
                        }
                        else if(element=='nid')
                        {
                            txt = 'NID';
                        }
                        else if(element=='branch')
                        {
                            txt = 'Work Location';
                        }
                        else
                        {
                            txt = this.stringView(element);
                        }
                        co = co.concat([{ text: txt , value: element }]);



                        available_colunms = available_colunms.concat(element);
                    });

                    this.column_options = this.column_options.concat(co);


                    // console.log('available_colunms');

                    // console.log(available_colunms);

                    // console.log('column_selected');

                    // console.log(this.column_selected);

                    let final_column_selected = [];
                    this.column_selected.forEach(element =>
                    {
                        if(available_colunms.includes(element))
                        {
                            // console.log('available_colunms_element');
                            // console.log(element);
                            final_column_selected.push(element);
                        }
                        else
                        {
                            // console.log('available_colunms_missing');
                            // console.log(element);
                            // //this.column_selected.splice(this.column_selected.lastIndexOf(element), 1);
                        }
                    });


                    // console.log('final_column_selected');
                    // console.log(final_column_selected);

                    this.column_selected = final_column_selected;

                    // console.log('column_selected');
                    // console.log(this.column_selected);

                }.bind(this));
            },
            stringView(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            stringViewReverse(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';

                str = str.replace(/ /g,"_").toLowerCase();

                return str;
            },
            setcolumn: function()
            {
                this.$cookies.set("report_column_selected", this.column_selected);

                this.$refs.dropdown.hide(true);
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }

        },
        created: function(){
            if(this.$cookies.isKey("report_column_selected"))
            {
                if(this.$cookies.get("report_column_selected") != null && this.$cookies.get("report_column_selected") != '')
                {
                    if(Array.isArray(this.$cookies.get("report_column_selected")))
                    {
                        this.column_selected = this.$cookies.get("report_column_selected");
                    }
                    else
                    {
                        this.column_selected = this.$cookies.get("report_column_selected").split(',');
                    }
                }
            }
            // End: Mustafijur : 8-24-25 Cookie

            this.getPayrollDefaultField();
            this.fiscal_year = this.getCurrentFinancialYear();
            this.getPayrollReporting();
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.details;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }

                //console.log("filtered_list");
                //console.log(filtered_list);
                return filtered_list;
            },
            paginatedData()
            {
                //console.log("filteredData");

                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

            filteredData2()
            {
                let filtered_list = this.variance_report_details;
                if (this.search2)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                // console.log("filtered_list");
                // console.log(filtered_list);
                return filtered_list;
            },
            paginatedData2()
            {
                return this.paginate(this.filteredData2, this.length2, this.pagination2.currentPage);
            },

            clickSelect()
            {
                var lt = this.column_selected_view.length;

                this.column_selected_view = this.column_selected;
                if(this.column_selected_view.length !=  lt)
                {
                    this.column_selected_view = this.column_selected;
                }

                // if(this.column_selected.indexOf('name') > -1){
                //     this.column_selected.splice('name', 1);
                // }
                this.show_selected = this.column_selected_view.join();
                this.show_selected = this.show_selected.replaceAll("_", " ");
                this.show_selected = this.show_selected.replaceAll(",", " , ");
                this.show_selected = this.capitalizeTheFirstLetterOfEachWord(this.show_selected);

                if(this.column_selected.length ==0)
                {
                    this.show_selected = 'None Selected';
                }

                this.$cookies.set("report_column_selected", this.column_selected,'24h');

            },

        }
    }
</script>
